import { useState } from "react";
import { NumberInput } from "@mantine/core";
import { useTranslation } from "react-i18next";

const MIN_PACE = 1;
const MAX_PACE = 100;

type PaceInputProps = {
  pace: number;
  onSave: (pace: number) => void;
};

export function PaceInput({ pace, onSave }: PaceInputProps) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState<string | number>(pace);

  const save = () => {
    const value = Number(draft);
    const isValid = Number.isInteger(value) && value >= MIN_PACE && value <= MAX_PACE;
    if (isValid && value !== pace) onSave(value);
    else if (!isValid) setDraft(pace);
  };

  return (
    <NumberInput
      w={210}
      label={t("headsetReleases.pace")}
      suffix={t("headsetReleases.paceSuffix")}
      min={MIN_PACE}
      max={MAX_PACE}
      allowDecimal={false}
      clampBehavior="strict"
      value={draft}
      onChange={setDraft}
      onBlur={save}
    />
  );
}
